export default __webpack_public_path__ + "static/img-channel-thumbnail-fourth-3357b2033c66eb0f77e85578da042dda.avif";